module.exports = __webpack_public_path__ + "img/brown-wooden-vase-near-the-window-1129413.3f6e32ed.jpg";